import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'poster-editor-item-spellcheck-panel';

export type PosterEditorItemSpellcheckModalProps = {
  showListOfIgnoredWords?: boolean;
};

export default function PosterEditorItemSpellcheckModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.POSTER_EDITOR_ITEM_SPELLCHECK_MODAL];
  });
  const [height, setHeight] = useState('170px');
  const [hasSnapPoints, setHasSnapPoints] = useState(false);

  const sizeData = useAppSelector((state) => {
    return state.panels.sizeDataHashmap[PANEL_ID];
  });
  const propertiesData = useAppSelector((state) => {
    return state.panels.panelPropertiesHashmap[PANEL_ID];
  });

  useEffect((): void => {
    if (sizeData?.height) {
      setHeight(sizeData.height);
    }
  }, [sizeData]);

  useEffect((): void => {
    if (propertiesData?.hasSnapPoints) {
      setHasSnapPoints(true);
    } else {
      setHasSnapPoints(false);
    }
  }, [propertiesData]);

  const maxWidth = '800px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_ITEM_SPELLCHECK_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
      doesBottomSheetHaveSnapPoints={hasSnapPoints}
    >
      <LazyPanel
        panelDirectoryName="poster-editor-item-spellcheck-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorSpellcheckModal = (props?: PosterEditorItemSpellcheckModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_ITEM_SPELLCHECK_MODAL,
      panelProps: {
        ...props,
        panelId: PANEL_ID,
      },
    })
  );
};
